import {TimeAccountData, TimeAccountVacationData} from "@/shared/timr";
import {VacationUnit} from "@/shared/timrTypes";
import {renderOvertimesPopoverContent, renderTravellingTimesPopoverContent} from "./timeAccountPopoverUtil";
import {formatDate, formatDuration, formatVacation, parseISODate} from "@/shared/utils/datefunctions";

export function setVacationYearRange(from: string, to: string) {
	if (from || to) {
		$("#vacationYear").text(formatDate(parseISODate(from)) + " " +
			messages["requests.workingTimeRequestsUser.vacationYear.to"] + " " +
			formatDate(parseISODate(to)));
	} else {
		$("#vacationYear").text("-");
	}
}

export function toggleTimeVacationAccountInfoPanelLoadingIndicator(showLoadingIndicator: boolean) {
	$("#timeVacationAccountInfoPanel-container-processing").toggle(showLoadingIndicator);
}

export function toggleOvertimesTravellingTimes(showOvertimes: boolean, showTravellingTimes: boolean) {
	// the  toggle conditions are specified by the explicit comparison with "true", otherwise it does not work if the value is undefined
	$("#timeVacationAccountInfoPanel #overtimesColumn").toggle(showOvertimes === true);
	$("#timeVacationAccountInfoPanel #travellingTimesColumn").toggle(showTravellingTimes === true);
	$("#timeVacationAccountInfoPanel #overtimesTravellingTimesRow").toggle(showOvertimes === true || showTravellingTimes === true);
}

export function setDurationFieldValues(container: JQuery, timeAccountData: TimeAccountData) {
	if (timeAccountData?.lastTimeAccountBalanceDate) {
		setDurationFieldValue(container.find(".workDurationTotal"), timeAccountData.workDurationCurrentTotalBalance);
		setDurationFieldValue(container.find(".workDurationCurrentPeriod"), timeAccountData.workDurationCurrentBalance);
		setDurationFieldValue(container.find(".workDurationLastPeriod"), timeAccountData.lastWorkDurationTotalBalance);
		setDurationFieldValue(container.find(".overtimeDurationTotal"), timeAccountData.overtimeDurationCurrentTotalBalance);
		setDurationFieldValue(container.find(".overtimeDurationCurrentPeriod"), timeAccountData.overtimeDurationCurrentBalance);
		setDurationFieldValue(container.find(".overtimeDurationLastPeriod"), timeAccountData.lastOvertimeDurationTotalBalance);
		setDurationFieldValue(container.find(".allowanceDurationTotal"), timeAccountData.allowanceDurationCurrentTotalBalance);
		setDurationFieldValue(container.find(".allowanceDurationCurrentPeriod"), timeAccountData.allowanceDurationCurrentBalance);
		setDurationFieldValue(container.find(".allowanceDurationLastPeriod"), timeAccountData.lastAllowanceDurationTotalBalance);
		$(".flexTimeIndicator").removeClass("red yellow green").addClass(timeAccountData.flexTimeIndicator?.toLowerCase());
	} else {
		container.find(".timeAccountDuration").text("-").removeClass("value-positive value-negative");
	}
}

export function setDurationFieldValueLabels(container: JQuery, timeAccountData: TimeAccountData) {
	if (timeAccountData?.lastTimeAccountBalanceDate) {
		const lastTimeAccountBalanceDate = parseISODate(timeAccountData.lastTimeAccountBalanceDate);
		const workDurationCurrentPeriodLastBalanceDate = container.find(".durationCurrentPeriodLastBalanceDate");
		workDurationCurrentPeriodLastBalanceDate.text("(" + formatDate(lastTimeAccountBalanceDate) + ")");
		workDurationCurrentPeriodLastBalanceDate.closest("div").prop("title", formatDate(lastTimeAccountBalanceDate));
		const nextBalanceDate = lastTimeAccountBalanceDate.add({days: 1});

		const workDurationCurrentPeriodBalanceDate = container.find(".durationCurrentPeriodBalanceDate");
		workDurationCurrentPeriodBalanceDate.text("(" + messages["report.timeAccountDashboard.since"] + " " + formatDate(nextBalanceDate) + ")");
		workDurationCurrentPeriodBalanceDate.closest("div").prop("title", messages["report.timeAccountDashboard.since"] + " " + formatDate(nextBalanceDate));
	} else {
		container.find(".durationCurrentPeriodLastBalanceDate").text("");
		container.find(".durationCurrentPeriodBalanceDate").text("");
	}
}

export function setVacationFieldValues(container: JQuery, timeAccountData: TimeAccountVacationData) {
	if (timeAccountData?.isInitialized) {
		setVacationFieldValue(container.find("#vacationConsumed"), timeAccountData.vacationConsumed, timeAccountData.vacationUnit);
		setVacationFieldValue(container.find("#vacationPlanned"), timeAccountData.vacationPlanned, timeAccountData.vacationUnit);
		setVacationFieldValue(container.find("#vacationLeft"), timeAccountData.vacationLeft, timeAccountData.vacationUnit, true);
		setVacationYearRange(timeAccountData.vacationYearFrom, timeAccountData.vacationYearTo);

		container.find(".vacationUnitLabel").text(getVacationUnitLabel(timeAccountData.vacationUnit));
	} else {
		container.find(".vacationDuration")
			.text("-")
			.removeClass("value-positive value-negative");
	}
}

export function setTimeAccountVacationFieldValues(container: JQuery, timeAccountData: TimeAccountVacationData, forceShowLoadingIndicator = false) {
	toggleTimeVacationAccountInfoPanelLoadingIndicator(forceShowLoadingIndicator);
	setDurationFieldValues(container, timeAccountData);
	setDurationFieldValueLabels(container, timeAccountData);
	setVacationFieldValues(container, timeAccountData);
	toggleWorkingTimeTrackingVacationAccountFields(timeAccountData);

	const showOvertimes = timeAccountData?.addOvertimes && timeAccountData?.workingTimeTracking;
	const showTravellingTimes = timeAccountData?.addTravellingTimes && timeAccountData?.workingTimeTracking;
	if (showOvertimes) {
		setOvertimeFieldValues(container, timeAccountData);
		setOvertimePopover(timeAccountData);
	}
	if (showTravellingTimes) {
		setTravellingTimeFieldValues(container, timeAccountData);
		setTravellingTimePopover(timeAccountData);
	}
	toggleOvertimesTravellingTimes(showOvertimes, showTravellingTimes);
}

export function setOvertimePopover(timeAccountData: TimeAccountVacationData) {
	const overtimesColumnElement = $("#overtimesColumn");
	overtimesColumnElement
		.data("timeAccountData", timeAccountData)
		.popover("destroy")
		.find("#overtimesColumnTitle")
		.text(timeAccountData.allowancesOnly ? messages["report.timeAccountDashboard.allowances"] : messages["report.timeAccountDashboard.overtimeAllowances"]);

	if (!timeAccountData.exitDate) {
		overtimesColumnElement.popover({
			trigger: "hover",
			placement: "top",
			selector: ".panel-body",
			container: ".content-wrapper",
			delay: {show: 500, hide: 0},
			html: true,
			template: "<div class=\"popover time-account-popover\" role=\"tooltip\"><div class=\"arrow\"></div><div class=\"popover-content\"></div></div>",
			content: function () {
				const overtimesColumn = $("#timeVacationAccountInfoPanel #overtimesColumn");
				const data = overtimesColumn.data("timeAccountData") as TimeAccountVacationData;
				// it's not necessary to check SecurityStatus.ifOvertimeAllowanceAllowed(), because td.overtime-accounts is invisible if this is not the case
				return renderOvertimesPopoverContent(data.overtimes, data.allowancesOnly);
			}
		});
	}
}

export function setTravellingTimePopover(timeAccountData: TimeAccountVacationData) {
	const travellingTimesColumnElement = $("#travellingTimesColumn");
	travellingTimesColumnElement
		.data("timeAccountData", timeAccountData)
		.popover("destroy");

	if (!timeAccountData.exitDate) {
		travellingTimesColumnElement.popover({
			trigger: "hover",
			placement: "top",
			selector: ".panel-body",
			container: ".content-wrapper",
			delay: {show: 500, hide: 0},
			html: true,
			template: "<div class=\"popover time-account-popover\" role=\"tooltip\"><div class=\"arrow\"></div><div class=\"popover-content\"></div></div>",
			content: function () {
				const travellingTimesColumn = $("#timeVacationAccountInfoPanel #travellingTimesColumn");
				const data = travellingTimesColumn.data("timeAccountData") as TimeAccountVacationData;
				return renderTravellingTimesPopoverContent(data.travellingTimes);
			}
		});
	}
}

export function setOvertimeFieldValues(container: JQuery, timeAccountData: TimeAccountVacationData) {
	if (timeAccountData?.isInitialized) {
		setDurationFieldValue(container.find("#overtimeSumLastDurationTotal"), timeAccountData?.overtimeSumLastDurationTotal);
		setDurationFieldValue(container.find("#overtimeSumDuration"), timeAccountData?.overtimeSumDuration);
		setDurationFieldValue(container.find("#overtimeSumDurationTotal"), timeAccountData?.overtimeSumDurationTotal);
	}
}

export function setTravellingTimeFieldValues(container: JQuery, timeAccountData: TimeAccountVacationData) {
	if (timeAccountData?.isInitialized) {
		setDurationFieldValue(container.find("#travellingTimeSumLastDurationTotal"), timeAccountData?.travellingTimeSumLastDurationTotal);
		setDurationFieldValue(container.find("#travellingTimeSumDuration"), timeAccountData?.travellingTimeSumDuration);
		setDurationFieldValue(container.find("#travellingTimeSumDurationTotal"), timeAccountData?.travellingTimeSumDurationTotal);
	}
}

/**
 * Toggles the field visibility depending on whether the trusted working time is active for the time account
 * If trust based working time feature flan feature is disabled
 * It behaves as if vacation account & workingTimeTracking = true, trustBasedWorkingTime = false
 * @param timeAccount
 */
export function toggleWorkingTimeTrackingVacationAccountFields(timeAccount: TimeAccountVacationData) {
	if (!timeAccount) {
		return;
	}
	const panel = $("#timeVacationAccountInfoPanel");
	const workingTimeTrackingDisabledInfo = panel.find(".workingTimeTrackingDisabledInfo");
	const workingTimeFields = panel.find(".workingTimeFields");
	const trustBasedWorkingTimeInfo = panel.find(".trustBasedWorkingTimeInfo");
	const previewButtonContainer = panel.find("#previewButtonContainer");
	const vacationAccountFields = panel.find(".vacationAccountFields");
	const vacationAccountDisabledInfo = panel.find(".vacationAccountDisabledInfo");
	const exitOnInfo = panel.find(".exitOnInfo");
	const overtimeAllowancesFields = panel.find(".overtimeAllowancesFields");
	const travellingTimeFields = panel.find(".travellingTimeFields");

	workingTimeFields.toggle(timeAccount.workingTimeTracking && !timeAccount.trustBasedWorkingTime && !timeAccount.exitDate);
	trustBasedWorkingTimeInfo.toggle(timeAccount.workingTimeTracking && timeAccount.trustBasedWorkingTime && !timeAccount.exitDate);
	workingTimeTrackingDisabledInfo.toggle(!timeAccount.workingTimeTracking && !timeAccount.exitDate);
	previewButtonContainer.toggle(timeAccount.workingTimeTracking && !timeAccount.trustBasedWorkingTime && !timeAccount.exitDate);

	vacationAccountFields.toggle(timeAccount.vacationAccount && !timeAccount.exitDate);
	vacationAccountDisabledInfo.toggle(!timeAccount.vacationAccount && !timeAccount.exitDate);

	exitOnInfo.toggle(!!timeAccount.exitDate);
	overtimeAllowancesFields.toggle(!timeAccount.exitDate);
	travellingTimeFields.toggle(!timeAccount.exitDate);

	if (timeAccount.exitDate) {
		exitOnInfo
			.find(".input-info-text")
			.html(`<i class="far fa-info-circle position-left" aria-hidden="true"></i> ${messages.withArguments("reports.export.timeAccount.exitOn", formatDate(parseISODate(timeAccount.exitDate)))}`);
	}
}

export function setVacationFieldValue(item: JQuery, value: number, unit: VacationUnit, styleValue = false) {
	if (value != null) {
		item.text(formatVacation(value, unit));
		item.val(value);
		if (styleValue) {
			styleValuePositiveNegative(item, value);
		}
	} else {
		item.text("-");
	}
}

export function setDurationFieldValue(item: JQuery, value: number) {
	if (value != null) {
		item.text(formatDuration(value, null, true));
		item.val(value);
		styleValuePositiveNegative(item, value);
	} else {
		item.text("-");
	}
}

export function getVacationUnitLabel(vacationUnit: string): string {
	return vacationUnit ? messages["vacationUnit." + vacationUnit] : "";
}

export function styleValuePositiveNegative(item: JQuery, value: number) {
	item.removeClass("value-positive");
	item.removeClass("value-negative");
	if (value === 0) {
		return;
	}
	item.addClass(value > 0 ? "value-positive" : "value-negative");
}
